
import Header from "./Component/layout/Header";
import logo from "./img/logoredcomp.png"
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Body from "./Component/layout/Body";
import Main from "./Component/layout/Main";



function App() {

  const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: (theme.vars ?? theme).palette.text.secondary,
  ...theme.applyStyles('dark', {
    backgroundColor: '#1A2027',
  }),
}));

  return (
    <div className="App">
      <Main />
 
    </div>
  );
}

export default App;
